//
// GENERATED by KVision
//
package pl.finn.forms.tw1

import io.kvision.remote.HttpMethod
import io.kvision.remote.KVServiceManager
import io.kvision.remote.registerKVisionServiceExceptions

expect class Tw1Service : ITw1Service

object Tw1ServiceManager : KVServiceManager<Tw1Service>(Tw1Service::class) {
    init {
        registerKVisionServiceExceptions()
        bind(ITw1Service::nowy, HttpMethod.POST, null)
        bind(ITw1Service::edycja, HttpMethod.POST, null)
        bind(ITw1Service::sprawdz, HttpMethod.POST, null)
        bind(ITw1Service::zapisz, HttpMethod.POST, null)
        bind(ITw1Service::podglad, HttpMethod.POST, null)
    }
}
